import { Eyebrow, Reveal } from "./motion";

const PENGERTIAN = [
    "Durasi pengerjaan: Reguler maksimum 3 hari · One Day maksimum H+1 · Express maksimum 6 jam · Satuan sesuai hari yang berlaku.",
    "Pencucian minimal 3 kg untuk Kiloan Reguler dan Kiloan One Day. Jika kurang dari 3 kg, item laundry tetap dihitung 3 kg. Minimal 2 kg untuk Express dan Pakaian Anak.",
    "Pekerjaan dilakukan sesuai jam kerja setiap cabang/outlet DigiKlin. Di luar jam tersebut, pekerjaan tidak dilakukan. Hari Minggu tidak dihitung sebagai hari layanan.",
    "Jika order masuk di hari Jumat untuk layanan Reguler, order selesai di hari Selasa (hari Minggu tidak dihitung sebagai hari kerja).",
    "Jika order masuk di hari Sabtu untuk layanan Reguler, order selesai di hari Rabu (hari Minggu tidak dihitung sebagai hari kerja).",
    "Permintaan Express di atas pukul 15.00 akan selesai pada pukul 10.00 keesokan harinya.",
];

const SK = [
    "Kami anggap Anda setuju dengan daftar harga yang kami berikan di nota.",
    "Jumlah berat yang ditimbang dan dijadikan nota adalah jumlah berat yang diterima, baik basah maupun kering.",
    "Wajib mengisi data diri lengkap minimal Nama Lengkap dan Nomor WhatsApp AKTIF.",
    "Bukti tagihan dan bukti pengambilan yang sah di dalam transaksi kami adalah melalui nota digital atau nota fisik.",
    "Jika pengambilan tidak disertai bukti sah (nota digital atau nota fisik), kami berhak menolak pengambilan tersebut demi keamanan dan kenyamanan pelanggan lainnya.",
    "Pengambilan tanpa nota wajib mengisi form pernyataan disertai foto/copy KTP.",
    "Pembayaran Member wajib menggunakan e-payment dan wajib pelunasan di awal. Jika tidak, dikenakan tarif Non-Member.",
    "Sisa Saldo E-Money Member tidak dapat diuangkan kembali.",
    "Untuk Laundry Kiloan, mohon menghitung jumlah item sebelum meninggalkan laundry dan menginformasikan kepada petugas untuk dicatat. Kehilangan karena tidak menghitung jumlahnya bukan tanggung jawab DigiKlin.",
    "Pemisahan dan penyortiran pakaian wajib dilakukan oleh Anda sebagai pemilik pakaian. Waspadai pakaian yang memerlukan perlakuan khusus (mudah luntur/sobek) — order terpisah dan infokan ke petugas agar diproses terpisah sesuai permintaan Anda.",
    "Jika terjadi kelunturan atau susut bahan pakaian, DigiKlin tidak bertanggung jawab jika dimasukkan ke dalam service kiloan.",
    "Pastikan tidak ada benda tertinggal di item laundry Anda (kertas, uang, label pakaian, benda tajam, dll.). Kami tidak memproses penggantian akibat kelalaian pemilik barang.",
    "Kami tidak bertanggung jawab atas kehilangan/kerusakan laundry bersih yang tidak diambil selama 2 minggu di outlet kami.",
    "Penentuan harga laundry dapat berbeda di beberapa tempat dan tidak dapat ditawar. Perubahan harga atau promo diinfokan lewat website atau media sosial.",
    "Kami menggunakan detergen dan parfum standar laundry tanpa mengetahui jenis alergi Anda. Sabun/parfum pribadi tidak diperkenankan; reaksi alergi yang terjadi bukan tanggung jawab kami, baik kiloan maupun satuan.",
    "Untuk item yang hilang (kiloan & satuan), wajib memberikan bukti berupa video lengkap saat membuka packingan agar kami dapat mencocokkan dengan data kami. Tata cara unboxing ada di poin 19.",
    "Kerusakan dan kehilangan akibat Force Majeure (bencana alam, huru-hara, kebakaran) tidak dapat kami proses untuk penggantian rugi.",
    "Pengaduan dilayani 1x24 jam setelah laundry diambil. Buka dan periksa laundry dalam tempo 1x24 jam dengan video unboxing lengkap sebagai data komplain. Lebih dari 2x24 jam atau video tidak lengkap, pengaduan tidak diproses dengan alasan apa pun.",
    "Tata cara unboxing video yang sah: rekam dari awal dan arahkan ke nota kertas dalam packingan secara jelas; buka packingan dan hitung satu per satu menghadap kamera; kirim video ke email digiklin@gmail.com disertai nomor nota dan deskripsi permasalahan. Keluhan tanpa bukti valid atau bersifat asumsi pribadi tidak kami terima.",
    "Klaim ganti rugi Laundry Kiloan dihitung: harga jasa kiloan ÷ jumlah item × jumlah item hilang × 10.",
    "Klaim ganti rugi Laundry Satuan sebesar 2x harga nota berdasarkan item yang hilang/luntur/rusak.",
    "Khusus boneka & bantal: perubahan bentuk setelah pencucian karena karakter/usia dacran menjadi risiko pihak Anda sepenuhnya; klaim ganti rugi satuan tidak dapat diproses.",
    "Khusus bed cover: tanpa permintaan treatment noda berat/bau apek secara tertulis di awal, proses hanya cuci biasa tanpa treatment khusus.",
    "Proses komplain maksimal 14 hari kerja dengan nota telah dibayarkan. Jika terbukti ada kesalahan dari laundry, penggantian dilakukan via transfer bank.",
];

export default function TermsSection() {
    return (
        <section
            id="syarat-ketentuan"
            data-testid="terms-section"
            className="relative overflow-hidden bg-ink py-24 lg:py-32"
        >
            <div className="pointer-events-none absolute -right-32 top-0 h-[420px] w-[420px] rounded-full bg-brand/10 blur-3xl" />
            <div className="pointer-events-none absolute -left-24 bottom-0 h-[320px] w-[320px] rounded-full bg-brand/5 blur-3xl" />

            <div className="relative mx-auto max-w-7xl px-6">
                <Reveal>
                    <Eyebrow light>Syarat & Ketentuan</Eyebrow>
                    <h2 className="mt-5 max-w-2xl font-display text-4xl font-extrabold tracking-tight text-white sm:text-5xl">
                        Ketentuan layanan DigiKlin.
                    </h2>
                    <p className="mt-5 max-w-2xl text-base leading-relaxed text-white/55">
                        Dengan menggunakan layanan DigiKlin, Anda dianggap telah
                        membaca dan menyetujui seluruh ketentuan berikut.
                    </p>
                </Reveal>

                {/* Pengertian Layanan */}
                <Reveal delay={0.1}>
                    <h3 className="mt-16 font-display text-2xl font-bold text-white">
                        Pengertian Layanan
                    </h3>
                </Reveal>
                <div className="mt-8 grid gap-x-10 gap-y-8 sm:grid-cols-2">
                    {PENGERTIAN.map((item, i) => (
                        <Reveal key={i} delay={i * 0.05}>
                            <div
                                data-testid={`terms-pengertian-${i + 1}`}
                                className="flex items-start gap-4 border-t border-white/10 pt-6"
                            >
                                <span className="font-display text-3xl font-extrabold text-brand-bright">
                                    {String(i + 1).padStart(2, "0")}
                                </span>
                                <p className="text-sm leading-relaxed text-white/60">
                                    {item}
                                </p>
                            </div>
                        </Reveal>
                    ))}
                </div>

                {/* S&K */}
                <Reveal delay={0.1}>
                    <h3 className="mt-20 font-display text-2xl font-bold text-white">
                        Syarat & Ketentuan Layanan
                    </h3>
                </Reveal>
                <div className="mt-8 gap-10 lg:columns-2" data-testid="terms-list">
                    {SK.map((item, i) => (
                        <div
                            key={i}
                            data-testid={`terms-item-${i + 1}`}
                            className="mb-7 flex break-inside-avoid items-start gap-4"
                        >
                            <span className="mt-0.5 grid h-7 w-7 shrink-0 place-items-center rounded-full bg-white/10 font-display text-xs font-bold text-brand-bright">
                                {i + 1}
                            </span>
                            <p className="text-sm leading-relaxed text-white/60">
                                {item}
                            </p>
                        </div>
                    ))}
                </div>

                <Reveal delay={0.1}>
                    <p className="mt-4 border-t border-white/10 pt-8 text-xs text-white/35">
                        Pertanyaan seputar syarat & ketentuan? Hubungi kami
                        lewat WhatsApp +62 857-1555-0050 atau email
                        digiklin@gmail.com.
                    </p>
                </Reveal>
            </div>
        </section>
    );
}
